import { MarketplaceOrderListPage } from "@/features/marketplace-order/pages/MarketplaceOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/marketplace-order/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["marketplace_inbound_orders.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: MarketplaceOrderListPage,
});
